import React from "react";
var __jsx = React.createElement;
import MainImageComponent from "../../../../components/UiKit/MainImageComponent/MainImageComponent";
import Form from "./Components/Form";
import stl from "./ServiceCentersComponent.module.css";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import BreadCrumb from "@componentsShared/BreadCrumb";
var ServiceCentersComponent = function ServiceCentersComponent(_ref) {
  var onFieldChange = _ref.onFieldChange,
    fields = _ref.fields,
    availableSCData = _ref.availableSCData,
    onSubmit = _ref.onSubmit,
    loading = _ref.loading;
  var _useTranslation = useTranslation(["web_service_centers"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.sCentersMainConatiner
  }, /*#__PURE__*/React.createElement(MainImageComponent, {
    image: CDN_LINK + "/assets/images/serviceCenters/service_center.webp",
    title: t("service_centers", {
      ns: "web_service_centers"
    }),
    className: stl.mainImageClass,
    BreadCrumbRenderer: function BreadCrumbRenderer(className) {
      return /*#__PURE__*/React.createElement(BreadCrumb, {
        className: className,
        links: [{
          title: t("service_centers", {
            ns: "web_common"
          })
        }]
      });
    }
  }), /*#__PURE__*/React.createElement(Form, {
    t: t,
    onFieldChange: onFieldChange,
    fields: fields,
    availableSCData: availableSCData,
    onSubmit: onSubmit,
    loading: loading
  })));
};
export default ServiceCentersComponent;